import { useCallback, useEffect, useState } from "react";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { getCurrentWorkspaceInfo } from "api/services/workspace-service";
import { usePatchWorkspaceMfa } from "hooks/usePatchWorkspaceMfa";
import { useEditWorkspaceName } from "hooks/useEditWorkspaceName";
import { IGetCurrentWorkspaceInfoModel } from "api/models/response/IGetCurrentWorkspaceInfoModel";

export const useWorkspaceInfo = () => {
    const { callAPI, loading: loadingWorkspace } = useWorkspaceApiCall<unknown, IGetCurrentWorkspaceInfoModel>(getCurrentWorkspaceInfo, '', 'workspaceInfo.error');
    const [workspaceInfo, setWorkspaceInfo] = useState<IGetCurrentWorkspaceInfoModel | null>(null);
    const { patchMfa, patching: patchingMfa } = usePatchWorkspaceMfa();
    const { editWorkspaceName, editingWorkspaceName } = useEditWorkspaceName();

    const fetchWorkspaceInfo = useCallback(async () => {
        const response = await callAPI(null);
        if (response?.status === 200 && response.data) {
            setWorkspaceInfo(response.data);
        }
    }, [callAPI]);

    useEffect(() => {
        fetchWorkspaceInfo();
    }, [fetchWorkspaceInfo]);

    return {
        workspaceInfo,
        loading: loadingWorkspace,
        editWorkspaceName,
        editingWorkspaceName,
        patchMfa,
        patchingMfa,
        refreshWorkspaceInfo: fetchWorkspaceInfo,
    };
};